import { useEffect } from 'react';
import { useSessionsStore } from '../../stores/sessionsStore';
import { SessionList } from './SessionList';
import { SessionViewer } from './SessionViewer';

export default function SessionsPage() {
  const { fetchTranscripts } = useSessionsStore();

  useEffect(() => {
    fetchTranscripts();
  }, [fetchTranscripts]);

  return (
    <div className="h-[calc(100vh-3.5rem)] flex flex-col">
      {/* Split panel */}
      <div className="flex flex-col md:flex-row flex-1 min-h-0">
        {/* Left sidebar */}
        <div className="w-full md:w-72 flex-shrink-0 border-b md:border-b-0 md:border-r border-border-subtle overflow-y-auto max-h-48 md:max-h-none">
          <SessionList />
        </div>

        {/* Right content */}
        <div className="flex-1 min-w-0">
          <SessionViewer />
        </div>
      </div>
    </div>
  );
}
